import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { ProductInventoryService } from 'common/data';

class ProductInventoryStore extends BaseStore {
	constructor(rootStore) {
		super(new ProductInventoryService(rootStore.app.baasic.apiClient));
	}

	@action async createBatch(productInventoryBatch, sourceOfChange) {
		const response = await this.service.createBatch(productInventoryBatch, sourceOfChange);
		this.item = response;
		return this.item.data;
	}

	@action
	findProductInventory = async filter => {
		const response = await this.service.find(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
		return response.data;
	};

	@action
	async sync(filter) {
		const response = await this.service.sync(filter);
		if (filter) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
	}
}

export default ProductInventoryStore;



// WEBPACK FOOTER //
// ./src/modules/product-inventory/stores/ProductInventoryStore.js